const Button = ({text, func=() => {}, clickable=true}) => {
    const OnClick = (event) => {
        event.preventDefault();
        func();
    }
    if (clickable) {
        return <button
            className={"border-b-4 py-5 px-10 rounded-full font-serif:Times font-semibold text-white shadow-md bg-pygblue border-blue-700"}
            onClick={e => OnClick(e)}
        >
            {text}
        </button>
    }
    return <div
        className={"border-b-4 py-5 px-10 rounded-full font-serif:Times font-semibold text-white shadow-md bg-gray-500 border-gray-700 text-center"}
    >
        {text}
    </div>
}

export default Button;